
export const theme = {
  colors: {
    bg: "var(--bg)",
    bgSoft: "var(--bg-soft)",
    card: "var(--card)",
    text: "var(--text)",
    subtext: "var(--subtext)",
    gold: "var(--gold)",
    accent: "var(--accent)",
    danger: "var(--danger)",
  },
  radius: {
    lg: "20px",
    xl: "28px",
  },
  shadow: {
    soft: "0 10px 40px rgba(0,0,0,.35)",
  }
};
export type Theme = typeof theme;
